// extracted by mini-css-extract-plugin
export default {"botao_novo":"BotaoNovo_botao_novo__nATDV"};